import { makeActionCreator } from '../../../redux-util/general-helpers';
import moment from 'moment';
import { getExpiration } from 'app/api/redux-ui/common/onboarding/selectors';

export const markSeen = makeActionCreator('onboarding.markSeen', 'id');

export const reset = makeActionCreator('onboarding.reset');

export function tryResetOnboarding() {
  return function(dispatch, getState) {
    const expires = getExpiration(getState());
    if (expires && moment(expires).isBefore(moment())) {
      dispatch(reset());
    }
  };
}



// WEBPACK FOOTER //
// ./src/app/api/redux-ui/common/onboarding/actions.js